/**
 * @module NormalSearch
 * @author Created by yanghongmei1
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { JDDevice, JDImage, JDText, JDTouchableWithoutFeedback } from '@jdreact/jdreact-core-lib';

import { pt } from '../../../../components/utiles';

export default class NormalSearch extends PureComponent {
    static defaultProps = {
        name: 'NormalSearch',
        title: '',
        list: [],
        pramsString: '',
        customStyle: {},
        talkParams: () => {} // 第一个参数是选择的list,第二个参数是传递过来的tabIndex(当前组件在大搜索中的index)没有就不回传
    }

    constructor(props) {
        super(props);
        this.state = {
            myList: this.props.list,
            pramsString: this.props.pramsString
        };
        this._selectItem = this._selectItem.bind(this);
    }

    render() {
        const {
            customStyle,
            title
        } = this.props;
        const { myList } = this.state;
        return (
            <View style={styles.m_container}>
                <View style={styles.m_content}>
                    <View style={styles.titleBox}><JDText style={styles.titleText}>{title}</JDText></View>
                    <View style={styles.m_contentInner}>
                        {myList.length > 0 && myList.map((item, index) => {
                            return (
                                <JDTouchableWithoutFeedback
                                    key={item.id + '_box'}
                                    contentContainerStyle={styles.m_itemBoxView}
                                    style={[customStyle, styles.m_itemBoxView]}
                                    onPress={() => this._selectItem(item, index)}>
                                    <View style={[customStyle, styles.m_itemBox, item.selected && styles.m_itemBoxChoosed]} key={item.id}>
                                        {item.icon ? <JDImage style={styles.m_icon} source={item.icon} resizeMode='contain' /> : null}
                                        {item.name && <JDText
                                            style={[styles.m_itemText, item.selected && styles.m_itemTextChoosed, item.disabled && styles.m_disabled]}
                                        >
                                            {item.name + 'm²'}{index === 0 ? '以下' : (index === myList.length -1 ? '以上' :'')}
                                        </JDText>}
                                    </View>
                                </JDTouchableWithoutFeedback>
                            );
                        })}
                    </View>
                </View>
            </View>
        );
    }

    componentDidMount() {
        // console.log('NormalSearch mounted in ', isWeb ? 'Web' : 'RN');
        const { pramsString, list } = this.props;
        if (pramsString && list && list.length > 0) {
            const paramsList = pramsString.split(',');
            const List = JSON.parse(JSON.stringify(list));
            for (let i = 0; i < paramsList.length; i++) {
                for (let j = 0; j < List.length; j++) {
                    if (paramsList[i] == List[j].id) {
                        List[j].selected = true;
                        break;
                    }
                }
            }
            this.setState({
                myList: List
            });
        } else {
            this.setState({
                myList: list
            });
        }
    }

    _selectItem(item, index) {
        if (item.disabled) {
            return;
        }
        const { myList } = this.state;
        const List = JSON.parse(JSON.stringify(myList));
        const length = List.length;
        if (item.multiple) { // 多选
            if (List[0].id === '' || List[length - 1].id === '') {
                // 有全部标签
                if (item.id === '') { // 点击全部
                    for (let i = 0; i < length; i++) {
                        List[i].selected = false;
                    }
                    List[index].selected = true;
                } else { // 多选时点击其他
                    List[index].selected = !item.selected;
                    for (let i = 0; i < length; i++) {
                        if (List[i].id === '') {
                            List[i].selected = false;
                        }
                    }
                }
            } else { // 没有全部标签
                List[index].selected = !item.selected;
            }
        } else { // 单选
            List[index].selected = !item.selected;
            for (let i = 0; i < length; i++) {
                if (i !== index) {
                    List[i].selected = false;
                }
            }
        }
        this.setState({
            myList: List
        });
    }

    _resetClick = () => {
        const { myList } = this.state;
        const newList = JSON.parse(JSON.stringify(myList));
        if (newList && newList.length > 0) {
            for (let i = 0; i < newList.length; i++) {
                newList[i].selected = false;
            }
            this.setState({
                myList: newList
            });
        }
    }

    _AllOkClick = () => {
        const { myList } = this.state;
        let params = [];
        for (let i = 0; i < myList.length; i++) {
            if (myList[i].selected) {
                params.push(myList[i]);
            }
        }
        this.props.talkParams(params);
    }
}

NormalSearch.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    list: PropTypes.array,
    pramsString: PropTypes.string,
    customStyle: PropTypes.any,
    talkParams: PropTypes.func
};

const styles = StyleSheet.create({
    m_container: {
    },
    m_content: {
        marginLeft: -pt(24)
    },
    m_contentInner: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start'
    },
    m_itemBoxView: {
        flexDirection: 'row',
        height: pt(64),
        alignItems: 'center',
        marginLeft: pt(24),
        marginBottom: pt(24)
    },
    m_itemBox: {
        flexDirection: 'row',
        borderColor: '#F6F6F6',
        borderWidth: JDDevice.getDpx(3),
        height: pt(64),
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F6F6F6',
        borderRadius: pt(32),
        paddingHorizontal: pt(22)
    },
    m_itemBoxChoosed: {
        backgroundColor: 'rgba(255,245,246,1)',
        borderColor: '#FA2C19'
    },
    m_icon: {
        width: pt(40),
        height: pt(40),
        marginRight: pt(10)
    },
    m_itemText: {
        textAlign: 'center',
        fontSize: pt(24),
        color: '#262626'
    },
    m_itemTextChoosed: {
        color: '#FA2C19'
    },
    m_disabled: {
        color: '#ffffff'
    },
    titleBox: {
        paddingHorizontal: pt(32),
        paddingBottom: pt(24)
    },
    titleText: {
        fontSize: pt(28),
        color: '#858687'
    }
});
